<div
  #sideInfoPane
  class="system-details"
  [ngClass]="{
    'details-expanded': showHideToggle,
    loading: !systemDetails,
  }"
>
  <div
    class="system-image"
    [ngClass]="{
      'has-product-picture': (hasProductPicture$ | async),
    }"
  >
    <img src="/portal/assets/scanner.svg" alt="Scanner" placeholder />
    <img
      style="z-index: 1"
      [src]="productPicture | async"
      [alt]="systemDetails?.systemName"
      [ngClass]="{
        loaded: (productPicture | async) !== undefined,
      }"
      alt="Product Picture"
    />
    <div
      class="product-name flex flex-column col-2"
      (click)="showHideToggle = !showHideToggle"
      (keyup.enter)="showHideToggle = !showHideToggle"
      tabindex="0"
    >
      <sh-text size="super-header" class="product-sno">
        <span class="hide-phone hide-tablet">Serial No. </span
        >{{ systemDetails?.systemSerialNumber }}
      </sh-text>
      <sh-text size="title-1" class="product-desc dark">
        {{ systemDetails?.systemName }}
      </sh-text>
      <div *ngIf="!isactiveSystem" class="flex flex-row align-c">
        <sh-icon icon="warning" size="xs"></sh-icon>
        <sh-text class="inactive-text" size="body">{{
          'inactive_system_text' | translate
        }}</sh-text>
      </div>
    </div>
  </div>
  <div class="system-info">
    <div class="basic-info">
      <div class="info-section customer-name">
        <sh-text size="body-2" color="secondary">Customer Name</sh-text>
        <sh-text size="body-1" color="primary" class="loading-skeleton">
          {{ systemDetails?.customerName || '-' }}
        </sh-text>
      </div>
      <div class="info-section location">
        <sh-text size="body-2" color="secondary">Country and City</sh-text>
        <sh-text size="body-1" color="primary" class="loading-skeleton">
          {{ systemDetails?.customerLocation || '-' }}
        </sh-text>
      </div>
      <div class="info-section functional-location">
        <sh-text size="body-2" color="secondary">Functional Location</sh-text>
        <sh-text size="body-1" color="primary" class="loading-skeleton">
          {{ systemDetails?.functionalLocation || '-' }}
        </sh-text>
      </div>
      <div class="info-section software-version">
        <sh-text size="body-2" color="secondary">Software Version</sh-text>
        <sh-text size="body-1" color="primary" class="loading-skeleton">
          {{ systemDetails?.systemSoftwareVersion || '-' }}
        </sh-text>
      </div>
    </div>

    <div
      class="delivery-dates"
      [ngClass]="{
        'details-expanded': showHideToggle,
        loading: srsConnectivityLoading$ | async,
      }"
    >
      <div class="info-section country-city-mobile">
        <sh-text size="body-2" color="secondary">Country and City</sh-text>
        <sh-text size="body-1" color="primary" class="loading-skeleton">
          {{ systemDetails?.customerLocation || '-' }}
        </sh-text>
      </div>
      <div
        *ngFor="let systemInformationDataRow of srsFields.systemInformationData"
        class="info-section"
        [ngClass]="{ loading: srsConnectivityLoading$ | async }"
      >
        <sh-text size="body-2" color="secondary">
          {{ systemInformationDataRow.label | translate }}
        </sh-text>
        <sh-text size="body-1" color="primary" class="loading-skeleton">
          {{ srsField(systemInformationDataRow.value) | async | localizedDate }}
        </sh-text>
      </div>
    </div>

    <hr class="seperator" />

    <div
      class="srs-connectivity-small loading-skeleton"
      [ngClass]="{
        'hide-phone': showHideToggle,
      }"
    >
      <sh-icon [icon]="connectivity_status_icon$ | async" size="s"></sh-icon>
      <sh-text size="title-1">&nbsp;SRS</sh-text>
    </div>

    <div
      class="srs-connectivity"
      [ngClass]="{
        'details-expanded': showHideToggle,
        loading: srsConnectivityLoading$ | async,
      }"
    >
      <div class="info-section icon-title flex align-c">
        <sh-icon
          class="loading-skeleton"
          [icon]="connectivity_status_icon$ | async"
          size="s"
        ></sh-icon>
        <sh-text class="loading-skeleton" size="title-1"
          >SRS Connectivity</sh-text
        >
      </div>
      <div
        class="info-section"
        *ngFor="
          let srsConnectivityDataRow of srsFields.srsConnectivityData;
          index as i
        "
      >
        <sh-text size="body-2" color="secondary">
          {{ srsConnectivityDataRow.label | translate }}
        </sh-text>
        <sh-text
          size="body-1"
          color="primary"
          class="loading-skeleton"
          id="{{ srsConnectivityDataRow.value }}_data"
        >
          {{
            srsField(srsConnectivityDataRow.value)
              | async
              | localizedDate
                : 'longFormat'
                : (srsField(srsConnectivityDataRow.value) | async) + '' || ''
          }}
          <sh-icon
            *ngIf="
              false &&
              srsConnectivityDataRow.tooltip &&
              srsConnectivityDataRow.label
            "
            id="tooltip-info-icon"
            icon="information"
            size="xs"
          >
          </sh-icon>
          <ng-container *ngIf="srsConnectivityDataRow.tooltip">
            <sh-tooltip
              label="{{ srsConnectivityDataRow.tooltip }}"
              target="{{ srsConnectivityDataRow.value }}_data"
            >
            </sh-tooltip>
          </ng-container>
        </sh-text>
      </div>
    </div>
  </div>
  <div
    class="collapsable-ic"
    (click)="showHideToggle = !showHideToggle"
    (keyup.enter)="showHideToggle = !showHideToggle"
    tabindex="0"
  >
    <sh-icon
      icon="{{ showHideToggle ? 'arrow-line-up-s' : 'arrow-line-down-s' }}"
    ></sh-icon>
  </div>
</div>
